#import "../../../../core/schema/fragments/VoucherFull.graphql"

query (
  $code: String!
) {
  getVoucherByCode(
    code: $code
  ) {
    ...VoucherFull
  }
}
